import { MyFavouritesButton } from '@/components/widgets/my-favourites-button';
import { useAccountInfo } from '@/hooks/query/account';
import { useAddMatchToMyFavourites, useMyFavourites, useRemoveMatchFromMyFavourites } from '@/hooks/query/my-favourties';
import { setKafkaNormal } from '@/hooks/query/use-kafka-log';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { convertSabaSportToNormalSport } from '@/utils/saba-sports-util';
import { KafkaNote } from '@nf/utils-common/constants';
import { MaybeMatch } from '@nf/utils-common/fpw/monadic';
import { useParams } from 'next/navigation';
import { useEffect, useState } from 'react';

interface MyFavouritesMatchButtonProps {
	matchId: number;
	sportType: number;
	time: string;
}

export const MyFavouritesMatchButton = ({
	matchId,
	sportType,
	time
}: MyFavouritesMatchButtonProps) => {
	const [isSelected, setIsSelected] = useState(false);
	const { data: myFavouritesData } = useMyFavourites();
	const { user } = useAccountInfo();
	const { SiteConfigsData } = useGetSiteConfigs();
	const addMatchToMyFavouritesMutation = useAddMatchToMyFavourites();
	const removeMatchFromMyFavouritesMutation = useRemoveMatchFromMyFavourites();
	const sport = convertSabaSportToNormalSport(sportType);
	const view = useAppearanceStore(state => state.view);
	const params = useParams();

	useEffect(() => {
		setIsSelected((myFavouritesData?.Mdata?.findIndex(matchData => matchData.MatchId === matchId) ?? -1) > -1)
	}, [matchId, myFavouritesData?.Mdata])

	const onToggleMyFavoriteButton = () => {
		setKafka();
		MaybeMatch(isSelected)
			.fold(
				() => addMatchToMyFavouritesMutation.mutate({
					MatchId: matchId,
					Time: time,
					SportType: sport
				}),
				() => removeMatchFromMyFavouritesMutation.mutate({
					MatchId: matchId
				})
			)
	}

	const setKafka = () => {
		const isShowRightMenu = window.innerWidth >= 1250;
		if (view === ViewEnum.mars && !isSelected && !isShowRightMenu) { // when add to fav
			const isSingleMatchPage = params.matchId !== undefined;
			const kafkaData = {
				note: KafkaNote.MarsV1,
				type: 6,
				action: isSingleMatchPage ? 23 : 1
			}
			setKafkaNormal(kafkaData);
		}
	}

	return user?.ActStatus === 2 && SiteConfigsData?.EnableMyFavorite ? (
		<MyFavouritesButton
			isSelected={isSelected}
			onToggleMyFavoriteButton={onToggleMyFavoriteButton}
		/>
	) : null;
}